import React from 'react';
import PropTypes from 'prop-types';
import Card from 'components/core/Card';
import Stack from 'components/core/Stack';
import Sheet from 'components/core/Sheet';
import Table from 'components/core/Table';
import IconButton from 'components/core/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

const EvidenceAddTable = ({ evidences, onRemove, observation }) => {
    const data = evidences.map((evidence, index) => {
        return {
            id: evidence.id,
            index,
            label: evidence.get ? evidence.get('label') : evidence.label || '',
            subjects: evidence.get ? (evidence.get('subjects') || []).map(s => s.get ? s.get('label') : s.label).join(', ') : '',
            format: evidence.get ? evidence.get('evidenceFormat')?.get('label') : evidence.evidenceFormat?.label || '',
        };
    });

    const columns = [
        { key: 'label', label: 'Label', width: '25%' },
        { key: 'subjects', label: 'Subjects', width: '50%' },
        { key: 'format', label: 'Format', width: '20%' }
    ];

    return (
        <Sheet sx={{ width: '100%', background: 'none', mt: 2, mb: 2 }}>
            <Card>
                <Table>
                    <thead>
                        <tr>
                            {columns.map(column => (
                                <th key={column.key} style={{ width: column.width }}>
                                    <Stack direction="row" alignItems="center">
                                        {column.label}
                                    </Stack>
                                </th>
                            ))}
                            <th style={{ width: '5%' }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map(evidence => (
                            <tr key={evidence.id || `temp-${evidence.index}`}>
                                <td>{evidence.label}</td>
                                <td>{evidence.subjects}</td>
                                <td>{evidence.format}</td>
                                <td>
                                    <IconButton 
                                        size="sm" 
                                        color="danger"
                                        onClick={() => onRemove(evidence.index)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Card>
        </Sheet>
    );
};

EvidenceAddTable.propTypes = {
    evidences: PropTypes.array.isRequired,
    onRemove: PropTypes.func.isRequired,
    observation: PropTypes.object
};

export default EvidenceAddTable;